"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKET_PRIORITY_ERROR_CODES = exports.PRIORITY_REQUIRED_MESSAGE = exports.setTicketPrioritySchema = exports.UNTRIAGED_LABEL = exports.TICKET_PRIORITY_LABELS = exports.TICKET_PRIORITIES = void 0;
exports.isTicketPriority = isTicketPriority;
exports.isReplyBlockedByPriorityRule = isReplyBlockedByPriorityRule;
const zod_1 = require("zod");
/**
 * Priorità del ticket (PRD-004 US-2, story #3): quattro livelli assegnati dal triage, mai visibili a
 * chi ha segnalato (DEC-002 regola 6). Un ticket senza priorità è «Da triare». I criteri di
 * attribuzione (che cosa è «Urgente») sono TBD nel PRD: qui solo valori ed etichette, nessuna
 * descrizione dei livelli.
 */
exports.TICKET_PRIORITIES = ['urgente', 'alta', 'media', 'bassa'];
exports.TICKET_PRIORITY_LABELS = {
    urgente: 'Urgente',
    alta: 'Alta',
    media: 'Media',
    bassa: 'Bassa',
};
/** Etichetta di un ticket senza priorità: visivamente distinta nella coda e nel dettaglio. */
exports.UNTRIAGED_LABEL = 'Da triare';
/** Vero se il valore è uno dei quattro livelli (la colonna ha un vincolo dalla migrazione 0009). */
function isTicketPriority(value) {
    return typeof value === 'string' && exports.TICKET_PRIORITIES.includes(value);
}
const INVALID_PRIORITY = 'Priorità non valida: urgente, alta, media o bassa';
/**
 * Corpo di `PUT /tickets/:code/priority`. La priorità non si rimuove: né il PRD né il prototipo
 * prevedono di riportare un ticket a «Da triare», quindi `null` è rifiutato.
 */
exports.setTicketPrioritySchema = zod_1.z.strictObject({ priority: zod_1.z.enum(exports.TICKET_PRIORITIES, { error: INVALID_PRIORITY }) }, {
    error: (issue) => (issue.code === 'unrecognized_keys' ? `Campi non ammessi: ${issue.keys.join(', ')}` : undefined),
});
/**
 * Regola «Priorità obbligatoria prima di rispondere» (PRD-004 US-2, US-6): vero se impedisce di
 * rispondere a chi ha segnalato, cioè se la regola è attiva e il ticket è «Da triare». Riguarda solo
 * ciò che manda un'email al segnalante (risposta, «Invia e chiudi»): nota interna e «Scarta» non la
 * consultano (DEC-002). Le impostazioni vanno lette al momento dell'uso, mai retroattivamente.
 */
function isReplyBlockedByPriorityRule(ticket, settings) {
    return settings.requirePriorityBeforeReply && ticket.priority === null;
}
/** Messaggio della regola: avviso vicino alla priorità nel dettaglio e testo dell'errore dell'API. */
exports.PRIORITY_REQUIRED_MESSAGE = 'Assegna una priorità per poter rispondere: la regola «Priorità obbligatoria prima di rispondere» è attiva.';
/** Codici di errore della priorità, nel campo `code` del corpo di errore dell'API. */
exports.TICKET_PRIORITY_ERROR_CODES = {
    /** Risposta su un ticket «Da triare» con la regola attiva (409). */
    priorityRequired: 'tickets.priorita_obbligatoria',
};
//# sourceMappingURL=ticket-priority.js.map